export function setFilters(state, filters) {
  state.filters = { ...filters };
}

export function setFilterOptions(state, options) {
  state.options = { ...options };
}
